import { Form, Input } from "decorator-form";
import { Entity, Field } from "typegraph";

import { ILayout } from "common/form/fields/layout/ILayoutType";
import { EntityMultiSelect } from "common/form/fields/entitySelect/EntityMultiSelect";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "../../core/components/FragmentProvider";
import * as fragments from "./userFragments";

@Entity({many: "properties"})
class Properties {
	@Field() public id: any;
	@Field() public displayName: string;
	@Field() public sortIndex: any;
}

const userFragmentInput = FragmentProvider.getLayoutInput(fragments);
const propertySelect = EntityMultiSelect.registered(Properties, {}, {valueKey: "id", nameKey: "displayName"});


@Form({ title: "User Details Panel Config" })
export default class UserDetailsConfig {

	@Input({type: userFragmentInput, title: "Layout"})
	public layout: ILayout<IFragmentLayoutConfig>;

	@Input({type: propertySelect, title: "Select Property to display in User Summary"})
	public propertyIds: any[];

}



// WEBPACK FOOTER //
// ./src/panels/userDetails/UserDetailsConfig.ts